/**
 * @generated SignedSource<<d2f782952686eed712879a157bd43b77>>
 * @relayHash 59e01a3075bb7b2c5ecf316ba853c07f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3991fc8cc0807d0b4a1581824366756c68b1584830e34d357825630fc2c43fc1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FieldsPageContentQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type FieldsPageContentQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly isExplicitFieldAssociationsEnabled: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"FieldsPageHeader">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"FieldsTable">;
};
export type FieldsPageContentQuery = {
  response: FieldsPageContentQuery$data;
  variables: FieldsPageContentQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": isNumberFieldConfigurationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": includeSingleSelectColorField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isNumberFieldConfigurationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-ui-enabled.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colourful-single-select-fields-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "isExplicitFieldAssociationsEnabled"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldsPageContentQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "FieldsTable"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "FieldsPageHeader"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "FieldsPageContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "xsmall"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "optionsPerFieldLimit"
              },
              {
                "concreteType": "JiraFieldTypeGroupConnection",
                "kind": "LinkedField",
                "name": "projectFieldTypeGroups",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldTypeGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldTypeGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "projectScopedFieldsPerProjectLimit"
              },
              {
                "kind": "ScalarField",
                "name": "projectScopedFieldsCount"
              },
              (v7/*: any*/),
              {
                "concreteType": "JiraProjectWithIssueTypeIds",
                "kind": "LinkedField",
                "name": "projectWithVisibleIssueTypeIds",
                "plural": false,
                "selections": [
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                    "kind": "LinkedField",
                    "name": "fieldAssociationWithIssueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                  },
                                  (v7/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "scope"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "description"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "hasMissingConfiguration"
                              },
                              {
                                "concreteType": "JiraFieldOperation",
                                "kind": "LinkedField",
                                "name": "fieldOperation",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canRemove"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canDelete"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canEdit"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canModifyOptions"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraFieldOptionConnection",
                                "kind": "LinkedField",
                                "name": "fieldOptions",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraFieldOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraFieldOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "optionId"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "parentOptionId"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "value"
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraColor",
                                                "kind": "LinkedField",
                                                "name": "color",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "colorKey"
                                                  },
                                                  (v7/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "fieldFormatConfig",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "formatStyle"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "formatUnit"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "formatDecimals"
                                          }
                                        ],
                                        "type": "JiraNumberFieldFormatConfig"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isFieldLocked"
                              },
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ],
                    "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                  },
                  {
                    "args": (v8/*: any*/),
                    "filters": [
                      "input"
                    ],
                    "handle": "connection",
                    "key": "fieldsTable_fieldAssociationWithIssueTypes",
                    "kind": "LinkedHandle",
                    "name": "fieldAssociationWithIssueTypes"
                  }
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3991fc8cc0807d0b4a1581824366756c68b1584830e34d357825630fc2c43fc1",
    "metadata": {},
    "name": "FieldsPageContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": isNumberFieldConfigurationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};
})();

(node as any).hash = "e049997372bcaa7f0003dc89def6e1bf";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
